import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../types/rtk/auth/login";

const initialState: AuthState = {
  external_id: undefined,
  delegation_token: undefined,
  token: undefined,
  tracker_id: undefined,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<Partial<AuthState>>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setAuth } = AuthSlice.actions;
const AuthReducer = AuthSlice.reducer;

export default AuthReducer;
